
/**
 * 歌曲 Model
 */
const extend = {
  aiGentool: '',
  aiTimestamp: null,
  publicTime: '',
}

export default class AiSong {
  lockBasic = false
  mediaFinish = false
  uploadPercent = 0
  hasError = false

  constructor(initObj = {}) {
    const trackExtend = {
      ...extend,
      ...initObj.trackExtend
    }

    this.tempId = initObj.trackId || `tempId_${Date.now()}`
    this.trackId = initObj.trackId
    this.tmeTrackId = initObj.tmeTrackId
    this.coverList = initObj.coverList || []
    this.trackName = initObj.trackName || ''
    this.language = initObj.language ? initObj.language : 0
    this.status = initObj.status || 0
    this.media = initObj.media ? initObj.media : null
    this.trackExtend = trackExtend
    this.lyricData = initObj.lyricData || {}

    this.genre = initObj.genre
      ? initObj.genre.split(',').map(v => +v)
      : []
  }
}
